import { useMemo } from 'react';
import { useSocialFeedSettings } from '../../utils';

export function useFormattedLinksText(text: string) {
  const { enableExternalLinks, openLinksNewTab, editMode } =
    useSocialFeedSettings();

  return useMemo(() => {
    if (!text) {
      return undefined;
    }

    const tmpDocument = document.implementation.createHTMLDocument('Temporary');
    let textLink: string | undefined;

    tmpDocument.body.innerHTML = text;

    const links = tmpDocument.querySelectorAll('a');

    links.forEach((link) => {
      if (!enableExternalLinks) {
        const textNode = document.createTextNode(
          link.firstChild?.nodeValue || ''
        );
        link.parentElement?.replaceChild(textNode, link);

        return;
      }

      if (!link.hasAttribute('data-without-preview') && !textLink) {
        textLink = link.href;
      }

      link.target = openLinksNewTab || editMode ? '_blank' : '_top';
    });

    return { formattedText: tmpDocument.body.innerHTML, textLink };
  }, [text, enableExternalLinks, openLinksNewTab, editMode]);
}
